import { WelcomeTour } from '../models/welcome-tour.interfaces';

export const WelcomeTourTrackerMocks: WelcomeTour = {
  header: 'SkyMiles® Simplified',
  slides: [
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-1.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-1-mobile.png'
      },
      content: {
        title: 'EARNING STATUS JUST GOT SIMPLE',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus faucibus consectetur diam et tristique. Quisque efficitur tristique risus, vitae dapibus nisl maximus non.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-2.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-2-mobile.png'
      },
      content: {
        title: 'SIMPLE TRACKING - JUST ONE QUALIFIER',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus faucibus consectetur diam et tristique. Quisque efficitur tristique risus, vitae dapibus nisl maximus non. '
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-3.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-3-mobile.png'
      },
      content: {
        title: 'REDEEMABLE MILES EASILY ACCESSIBLE',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus faucibus consectetur diam et tristique. Quisque efficitur tristique risus, vitae dapibus nisl maximus non.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-4.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-4-mobile.png'
      },
      content: {
        title: 'TRACK YOUR LIFETIME MILES FLOWN',
        subtitle:
          'The Medallion Status trackers are made up of two categories — Flight and Spend. Reach status by completeing a qualifier in each category.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-5.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-5-mobile.png'
      },
      content: {
        title: 'SEE YOUR MQD EARNINGS BY CATEGORY',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus faucibus consectetur diam et tristique. Quisque efficitur tristique risus, vitae dapibus nisl maximus non.'
      }
    }
  ],
  disabled: false,
  loaded: true,
  analyticsEvent: {
    name: 'sm-modal-ready',
    value: 'Skymiles Tour Modal'
  },
  ariaLabels: {
    close: 'close welcome tour',
    action: {
      next: 'next welcome tour slide',
      previous: 'previous welcome tour slide'
    }
  }
};
